<template>
    <div class="form-field" :class="{required}">

        <ValidationProvider key="addressRoot" v-slot="{ errors }" persist>

            <div class="form-group">

                <div class="form-field-label" :class="{required, 'validation-error': errors.length > 0 }">{{label}}</div>

                <div class="container">

                    <Row>
                        <div class="form-field col">

                            <ValidationProvider :name="name + '.line1'" rules="required" v-slot="{ errors }" persist>

                                <label class="form-field-label required" :for="name + '.line-1'" :class="{'validation-error': errors.length > 0 }">Line 1</label>
                                <input class="form-control"
                                       :class="{'validation-error': errors.length > 0 }"
                                       type="text"
                                       :id="name + '.line-1'"
                                       :name="name + '.line-1'"
                                       :value="value.line1"
                                       @input="onInput('line1', $event.target.value)"
                                >

                                <p v-if="errors[0]" class="validation-error">{{errors[0]}}</p>

                            </ValidationProvider>

                        </div>
                    </Row>

                    <Row class="my-2">
                        <div class="form-field col">
                            <label class="form-field-label" :for="name + '.line-2'">Line 2</label>
                            <input class="form-control"
                                   type="text"
                                   :id="name + '.line-2'"
                                   :name="name + '.line-2'"
                                   :value="value.line2"
                                   @input="onInput('line2', $event.target.value)"
                            >
                        </div>
                    </Row>

                    <Row>

                        <div class="form-field col">
                            <ValidationProvider :name="name + '.city'" rules="required" v-slot="{ errors }" persist>
                                <label class="form-field-label required" :for="name + '.city'"
                                       :class="{'validation-error': errors.length > 0 }">City</label>
                                <input class="form-control"
                                       :class="{'validation-error': errors.length > 0 }"
                                       type="text"
                                       :id="name + '.city'"
                                       :name="name + '.city'"
                                       :value="value.city"
                                       @input="onInput('city', $event.target.value)"
                                >
                                <p v-if="errors[0]" class="validation-error">{{errors[0]}}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-field col">
                            <ValidationProvider :name="name + '.county'" v-slot="{ errors }" persist>
                                <label class="form-field-label" :for="name + '.county'"
                                       :class="{'validation-error': errors.length > 0 }">County</label>
                                <input class="form-control"
                                       :class="{'validation-error': errors.length > 0 }"
                                       type="text"
                                       :id="name + '.county'"
                                       :name="name + '.county'"
                                       :value="value.county"
                                       @input="onInput('county', $event.target.value)"
                                >
                                <p v-if="errors[0]" class="validation-error">{{errors[0]}}</p>
                            </ValidationProvider>
                        </div>

                        <div class="form-field col">
                            <ValidationProvider :name="name + '.postCode'" rules="required" v-slot="{ errors }" persist>
                                <label class="form-field-label required" :for="name + '.postCode'" :class="{'validation-error': errors.length > 0 }">Post
                                    Code</label>
                                <input class="form-control"
                                       :class="{'validation-error': errors.length > 0 }"
                                       type="text"
                                       :id="name + '.postCode'"
                                       :name="name + '.postCode'"
                                       :value="value.postCode"
                                       @input="onInput('postCode', $event.target.value)"
                                >
                                <p v-if="errors[0]" class="validation-error">{{errors[0]}}</p>
                            </ValidationProvider>
                        </div>

                    </Row>

                </div>
            </div>

        </ValidationProvider>

    </div>
</template>

<script>
    import {ValidationProvider} from "vee-validate"
    import Row from '../layout/Row'
    import Col from '../layout/Col'

    export default {
        name: "AddressInput",
        props: ["name", "label", "value", "required"],
        components: {
            ValidationProvider,
            Row,
            Col
        },
        methods: {
            onInput: function (fieldName, value) {
                this.value[fieldName] = value
            }
        }
    }
</script>

<style lang="scss" scoped>
    .form-field-label {
        &.required {
            &:after {
                content: '*';
                color: red;
            }
        }
    }
</style>
